// VolumeController.js
'use strict';
import { connect } from 'react-redux';
import setPlayerData from '../action/setPlayerData.js';
import setShouldDisplayUnmuteHint from '../action/setShouldDisplayUnmuteHint.js';
import getIsCoveredByEntryGate from '../selector/getIsCoveredByEntryGate.js';
import getOperationData from '../selector/getOperationData.js';
import getRemoteConfigData from '../selector/getRemoteConfigData.js';
import VolumeController from '../component/VolumeController.jsx';
import {
  FEATURE_LIVESTREAM_UNMUTE_HINT_ENABLED,
  LIVESTREAM_UNMUTE_HINT_DURATION_SECONDS,
} from '../RemoteConfigKeys.js';

const mapStateToProps = state => {
  const volume = getOperationData(state, ['player'], 'volume');
  const isMuted = getOperationData(state, ['player'], 'isMuted');
  const isDragToMute = getOperationData(state, ['player'], 'isDragToMute');
  const volumeBeforeDragToMute = getOperationData(
    state,
    ['player'],
    'volumeBeforeDragToMute'
  );

  return {
    volume,
    isMuted,
    isDragToMute,
    volumeBeforeDragToMute,
    isCoveredByEntryGate: getIsCoveredByEntryGate(state),
    isUnmuteHintEnabled: !!getRemoteConfigData(
      state,
      FEATURE_LIVESTREAM_UNMUTE_HINT_ENABLED
    ),
    shouldDisplayUnmuteHint: !!getOperationData(
      state,
      ['liveStream'],
      'shouldDisplayUnmuteHint'
    ),
    unmuteHintDurationSeconds: getRemoteConfigData(
      state,
      LIVESTREAM_UNMUTE_HINT_DURATION_SECONDS
    ),
  };
};

const mapDispatchToProps = dispatch => {
  return {
    setPlayerData: data => dispatch(setPlayerData(data)),
    markUnmuteHintSeen: () =>
      dispatch(setShouldDisplayUnmuteHint({ shouldDisplayUnmuteHint: false })),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(VolumeController);
